/*
 *
 * Ctydents reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_STUDENTS,
  LOAD_STUDENTS_SUCCESS,
  LOAD_STUDENTS_ERROR,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUCCESS,
  UPDATE_STUDENT_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  loadingUpdate: false,
  studentDetail: false,
  itemsList: false,
  firstElem: false,
};

import { notification } from 'antd';

/* eslint-disable default-case, no-param-reassign */
const studentsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_STUDENTS:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = false;
        draft.firstElem = false;
        break;

      case LOAD_STUDENTS_SUCCESS:
        draft.loading = false;
        draft.firstRender = false;
        draft.itemsList = action.itemsList;
        draft.firstElem = action.itemsList?.data[0];
        break;

      case LOAD_STUDENTS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        draft.itemsList = false;
        draft.firstElem = false;
        break;

      // Update for Single Element
      case UPDATE_STUDENT:
        draft.firstRender = false;
        draft.loadingUpdate = false;
        draft.error = false;
        draft.studentDetail = action.studentDetail;
        break;

      case UPDATE_STUDENT_SUCCESS:
        draft.loadingUpdate = false;
        const { studentDetail } = action;

        if (studentDetail?._id) {
          draft.studentDetail = studentDetail;

          let listData = draft.itemsList.data;
          let index = draft.itemsList.data.findIndex(
            po => po._id === studentDetail._id,
          );
          index !== -1
            ? (listData[index] = studentDetail)
            : listData.unshift(studentDetail);
          draft.itemsList = { ...draft.itemsList, data: listData };
        } else {
          draft.courseDetail = false;
          if (studentDetail?.code == 500) {
            notification.warning({
              message: ``,
              description: courseDetail?.message,
            });
          }
        }

    
        
        break;

      case UPDATE_STUDENT_ERROR:
        draft.error = action.error;
        draft.loadingUpdate = false;
        break;
    }
  });

export default studentsReducer;
